import { memo } from 'react';

import type { FileChartWidgetData } from '@/features/_shared/widget-registry';
import { ChartProvider } from '@/features/charts/context/ChartContext';
import CustomChart from '@/features/markets/components/CustomChart';
import { PageInformationContext } from '@/shared/lib/PageInformationContext';

export const FileChartWidget = memo(({ data }: { data: FileChartWidgetData }) => {
  const metadata: Record<string, object | string> = {
    graphType: 'custom',
    seriesFileName: data.seriesFileName,
    configFileName: data.configFileName,

    ...(data.queryFileId === undefined ? {} : { queryFileId: data.queryFileId }),
    ...(data.downloadFileId === undefined ? {} : { downloadFileId: data.downloadFileId }),
    ...(data.timeRangeButtons === undefined ? {} : { timeRangeButtons: data.timeRangeButtons })
  };

  return (
    <PageInformationContext value={{ mainPageTitle: 'AI Chat' }}>
      <ChartProvider>
        <CustomChart metadata={metadata} />
      </ChartProvider>
    </PageInformationContext>
  );
});

FileChartWidget.displayName = 'FileChartWidget';
